import React, { Component } from 'react';
import { Form } from 'react-form';
import TextFields from '../UI/TextFiled';
import RadioGroup from '../UI/Radio';
import Breadcrumb from '../UI/Breadcrumb';
import DatePickerUI from '../UI/DatePicker';
import AutoComplete from 'material-ui/AutoComplete';


class AddCustomer extends Component {
    submitted = submittedValues => {
        console.log('submittedValues: ', submittedValues);
    };
    state = {
        dataSource: [],
    };

    handleUpdateInput = (value) => {
        this.setState({
            dataSource: [
                value,
                value + value,
                value + value + value,
            ],
        });
    };

    render() {
        return (
            <React.Fragment>
                <div className="page-title">
                    <div className="container">
                        <div className="row flex-center-y justify-between">
                            <div className="col-xs-12 text-center">
                                <h1 className="color-grey capitalize">Create new Code</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <Breadcrumb from={[{link: '/user-relationship/promotional-codes-management', label: 'Personal Credit Codes'}]} current="New Personal Credit Codes"/>
                </div>

                <div className="container box inner-padding mb-15">
                    <Form onSubmit={ this.submitted }>
                        { formApi => (
                            <form onSubmit={formApi.submitForm}>
                                <div className="box-body">

                                    <div className="row justify-between">
                                        <div className="col-xs-6 pr-70">
                                            <div className="mt-25">
                                                <p className="color-grey50 font-sm w-700 pb-10">Code</p>
                                                <p className="color-primary w-700">564</p>
                                            </div>
                                            <div className="mt-25">
                                                <p className="color-grey50 font-sm w-700 pb-10">Discount</p>
                                                <RadioGroup labelFirst="Free Credit" valueFirst="free_credit" labelSecond="Free Delivery" valueSecond="free_delivery" field="" />
                                            </div>
                                            <TextFields type="text" label="Credit Amount" field="credit_amount"/>
                                            <DatePickerUI label="Expiry Date"/>
                                            <div>
                                                <AutoComplete
                                                    hintText="Type anything"
                                                    dataSource={this.state.dataSource}
                                                    onUpdateInput={this.handleUpdateInput}
                                                />
                                                <ul className="tags with-close mt-20">
                                                    <li><span>Ashot Simonyan </span><span className="fa fa-times-circle close"></span></li>
                                                    <li><span>Ashot Simonyan</span><span className="fa fa-times-circle close"></span></li>
                                                    <li><span>Ashot Simonyan</span><span className="fa fa-times-circle close"></span></li>
                                                    <li><span>Ashot Simonyan</span><span className="fa fa-times-circle close"></span></li>
                                                </ul>
                                            </div>
                                        </div>


                                    </div>
                                </div>

                            </form>
                        )}
                    </Form>
                </div>
            </React.Fragment>
        );
    }
}

export default AddCustomer;



// WEBPACK FOOTER //
// ./src/components/User-relationship/NewPersonalCreditCodes.js